module.exports = __webpack_public_path__ + "static/img/vivo X200 Pro.4b8e699d.png";